import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TestCard from "./TestCard";
import "./PaperListing.css";
import Tabs from "./Tabs";

export default function PaperListing() {
  const { tabs, list, loading } = useSelector((state) => state.aitsTests);
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    if (tabs && tabs.length > 0) {
      setActiveTab(tabs[0]);
    }
  }, [tabs]);

  const filteredTests = list?.filter((test) => {
    if (activeTab === "All Tests") return true;

    if (activeTab === "Completed") {
      return test.is_submited === 1;
    }

    if (test.tab_name) {
      return test.tab_name === activeTab;
    }

    return true;
  });

  return (
    <div className="paperListingWrapper">
      {tabs.length > 0 && (
        <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
      )}

      <div className="paperListingContent">
        {filteredTests.length > 0
          ? filteredTests.map((test) => {
            return <TestCard key={test.id} test={test} />;
          })
          : !loading && <p className="no_tests_text">No tests found.</p>}
      </div>
    </div>
  );
}
